<template>
  <v-list class="admin-toolbar py-0" style="overflow: auto; height: calc(100vh - 64px)">
    <Dashboard />
    <v-divider />
    <Students v-if="$auth.policies['view-student-group']" />
    <Teachers v-if="$auth.policies['view-teacher-group']" />
    <EducationProgramsManagement />
    <Classes v-if="$auth.policies['view-class-group']" />
    <TimeTables v-if="$auth.policies['view-schedule-group']" />
    <v-divider />
    <!-- <CRM /> -->
    <TuitionFee v-if="$auth.policies['view-tuition-fee-group']" />
    <Posts v-if="$auth.policies['view-contactBook-group']" />
    <Feedback v-if="$auth.policies['view-feedback-group']" />
    <Settings v-if="$auth.policies['view-setting-group']" />
  </v-list>
</template>
<script>
import Classes from '@/components/basic/menu/Classes'
import TimeTables from '@/components/basic/menu/TimeTables'
import Students from '@/components/basic/menu/Students.vue'
import Teachers from '@/components/basic/menu/Teachers.vue'
import EducationProgramsManagement from '@/components/basic/menu/EducationProgramsManagement.vue'
import Dashboard from '@/components/basic/menu/Dashboard'
import Settings from '@/components/basic/menu/Settings.vue'
import Posts from '@/components/basic/menu/Posts.vue'
import Feedback from '@/components/basic/menu/Feedback.vue'
import TuitionFee from '@/components/basic/menu/TuitionFee.vue'
// import CRM from '@/components/basic/menu/CRM.vue'
export default {
  components: {
    Dashboard,
    Classes,
    TimeTables,
    Students,
    Teachers,
    Posts,
    Settings,
    Feedback,
    TuitionFee,
    EducationProgramsManagement,
    // CRM,
  },
}
</script>
<style>
.v-navigation-drawer__content .v-list-item__title {
  font-size: 14px;
}
.v-navigation-drawer__content::-webkit-scrollbar {
  width: 0px;
}
</style>
